// plugins/api.ts
import axios, { type AxiosInstance } from 'axios'

export default defineNuxtPlugin(() => {
   const config = useRuntimeConfig()

  const baseURL = process.server
    ? config.apiInternalBase
    : config.public.API_BASE_URL_WEB

  // SSR: prosledi cookie/auth ako postoje (public rute ignorišu)
  const forwardHeaders = process.server
    ? useRequestHeaders(['cookie', 'authorization'])
    : {}

  const apiAxios: AxiosInstance = axios.create({
    baseURL: baseURL,
    //withCredentials: true, // ok i za public i za auth rute
    timeout: 8000,
   headers: {
     'content-type': 'application/json' 
  
   }
  })

  return {
    provide: {
      apiAxios, // koristiš kao $api
    },
  }
})
